export const FETCH_PERMISSION_GROUPS = '@admission/FETCH_PERMISSION_GROUPS';
